import {
  GetAllAvailableOrganizationsRequiredTagsEnum,
  GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useEffect } from 'react';

import { useGetLimitedPostsBySelectedGeoAreas } from '@/features/api/hooks/grapevine-post/useGetLimitedPostsBySelectedGeoAreas';
import { useFeature } from '@/features/feature-management/provider/useFeature';
import { FeaturesEnum } from '@/features/feature-management/types/features';
import { useGetPostsParams } from '@/features/posts/hooks/useGetPostsParams';
import { PostFeedType } from '@/features/posts/types/postFeed';
import { KatwarnCard } from '@/features/start/components/header/civil-protection/KatwarnCard';
import { TabRoute } from '@/navigation/types/navigation';
import { useBadgeStore } from '@/shared/store/useBadgeStore';
import { hasItems } from '@/shared/utils/array';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

export const useKatwarnCard = () => {
  const theme = useAppTheme();
  const { isFeatureEnabled } = useFeature();
  const updateBadge = useBadgeStore((state) => state.updateBadge);

  // Katwarn deliberately stays global: not restricted to the explicitly
  // selected geo areas (onlyExplicitlySelectedGeoAreas: false).
  const civilProtectionParams = useGetPostsParams(
    PostFeedType.CIVIL_PROTECTION,
    {
      onlyExplicitlySelectedGeoAreas: false,
      sortBy: GetAllPostsByAppVariantAndSelectedGeoAreasSortByEnum.Created,
      requiredOrganizationTags: [
        GetAllAvailableOrganizationsRequiredTagsEnum.CivilProtection
      ]
    }
  );

  const { data: civilProtectionPosts } = useGetLimitedPostsBySelectedGeoAreas(
    civilProtectionParams
  );

  const show =
    isFeatureEnabled(FeaturesEnum.CivilProtection) &&
    hasItems(civilProtectionPosts);

  useEffect(() => {
    updateBadge(TabRoute.Start, show ? '!' : '0', theme.colors.error);
  }, [show, updateBadge, theme.colors.error]);

  if (!show) return;

  return <KatwarnCard items={civilProtectionPosts} />;
};
